import React, { useState } from 'react';

import BranchStaticField from './BranchStaticField';
import NumberPromptModal from './NumberPromptModal';

import { createToggleModalOpen } from '../utils';

const EditableNumberField = ({ label, question, onChange, ...otherProps }) => {
  const [isPromtModalOpen, setIsPromptModalOpen] = useState(false);

  const togglePromptModalOpen = createToggleModalOpen(setIsPromptModalOpen);

  const promptModalSubmitHandler = value => {
    setIsPromptModalOpen(false);
    onChange(value);
  };

  return (
    <>
      <BranchStaticField label={label} {...otherProps} onValueClick={togglePromptModalOpen} />
      <NumberPromptModal
        open={isPromtModalOpen}
        onSubmit={promptModalSubmitHandler}
        onCancel={togglePromptModalOpen}
        title={question || label}
        fieldText="Enter new value"
      />
    </>
  );
};

export default EditableNumberField;
